import type { App } from 'vue';
import { useFirebaseStore } from '@/shared/composables/feature-toggle';

export default {
  install(_: App) {
    const store = useFirebaseStore();
    store.fetchConfig(); // Запускаем автоматически при подключении
  },
};
